import { createGlobalStyle } from 'styled-components';

import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-toastify/dist/ReactToastify.css';

export default createGlobalStyle`
  ${
    '' /* @font-face {
    font-family: 'Saira';
    src: local('Saira'), local('Saira'),
    url(${sairaLight}) format('OpenType');
    font-weight: 300;
    font-style: normal;
  } */
  }

  :root {
    --white: #fff;
    --whiteDark: #f5f5f5;
    --grayLight: #EEEEEE;
    --gray: #bbb;
    --grayDark: #767676;
    --blueDark: #1c2156;
    --coolGrey: #E8E8E8;
    --black: #000;
    --salmon: #fb6f91;
    --yellowDark: #f7c325;
    --greenDark: #20303d;
    --blueUrl: #94d3fe;
  }

 * {
   margin: 0;
   padding: 0;
   outline: 0;
   box-sizing: border-box;
 }

 *:focus {
   outline: 0;
 }

 html, body, #root {
   height: 100%;
 }

 body {
   -webkit-font-smoothing: antialiased;
 }

 body, input, button {
   font-family: 'Saira', sans-serif
 }

 a {
   text-decoration: none;
 }

 ul {
   list-style: none;
 }

 button {
   cursor: pointer;
   border: none;
   background: none;
   font-size: initial;
   font-weight: initial;
 }
`;
